import { STORES_API } from 'modules/stores/api/stores-api'
import { StoreListApiInterface } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export const useStores = () => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, StoreListApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: stores, mutate } = useSWR(
    () => user && `${STORES_API}?page=1&itemsPerPage=50`,
    fetcher,
  )

  return { stores, mutate }
}
